export const pickToken = (tokens, colorContext) => {
    return tokens[colorContext];
};
//# sourceMappingURL=helper.js.map